import { useSupabase } from "../../contexts/SupabaseContext";
import { STATIC_STRINGS } from "@asez/shared";
import GradientLink from "./GradientLink";
import { useLocation, useNavigate } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { supabase, session } = useSupabase();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/login", { replace: true });
  };

  return (
    <div className="sidebar-container">
      <div className="logo-container">
        <div className="w-10 h-10 bg-blue-500 flex items-center justify-center rounded-full">
          <span className="text-lg font-bold">A</span>
        </div>
        <h1 className="text-xl font-semibold">Asez</h1>
      </div>

      <div className="nav-container">
        <nav className="space-y-4">
          <GradientLink
            to="/"
            aria-label="Dashboard"
            classes="w-full"
            selected={location.pathname === "/"}
          >
            {STATIC_STRINGS.DASHBOARD}
          </GradientLink>
          <GradientLink
            to="/assessments"
            aria-label="Assessments"
            classes="w-full"
            selected={location.pathname === "/assessments"}
          >
            {STATIC_STRINGS.ASSESSMENTS}
          </GradientLink>
        </nav>
      </div>

      <div className="footer">
        <GradientLink
          aria-label="Organisation Settings"
          classes="w-full"
          to="/settings"
          selected={location.pathname === "/settings"}
        >
          {STATIC_STRINGS.ORG_SETTINGS}
        </GradientLink>
        <GradientLink
          aria-label="Logout"
          classes="w-full"
          onClick={handleLogout}
        >
          {STATIC_STRINGS.LOG_OUT}
        </GradientLink>
      </div>
    </div>
  );
};

export default Sidebar;
